// SEE BACKEND LOGIC IN: packages/server/src/modules/okr/objective-attachment-helper.ts
export const useObjectiveAttachmentHelper = (
  base64DecodeFunction: (value: string) => string,
): {
  extractHumanReadableFileName: (objectiveAttachmentFileName: string) => string
} => {
  const extractHumanReadableFileName = (objectiveAttachmentFileName: string) => {
    try {
      const base64Part = objectiveAttachmentFileName.slice(objectiveAttachmentFileName.indexOf('_') + 1)
      try {
        return base64DecodeFunction(base64Part.replace(/_/g, '/').replace(/-/g, '=')) // return decoded filename
      } catch (err1) {
        console.log('error decoding attachment filename', err1)
        return 'error.txt'
      }
    } catch (err) {
      console.log('error decoding attachment filename', err)
      return 'error.txt'
    }
  }
  return {
    extractHumanReadableFileName,
  }
}

export const atobUtf8 = (enc: string): string => {
  return decodeURIComponent(
    atob(enc)
      .split('')
      .map((c) => {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
      })
      .join(''),
  )
}
